<template>
  <div class="index-case">
    <div class="container-md">
      <div class="nav-box">
        <div
          class="nav-item"
          :class="{'active':activeIndex === index}"
          v-for="(item,index) in caseContentInfo"
          :key="index"
          @click="activeIndex=index"
        >{{ item.title }}</div>
      </div>
      <div class="case-content">
        <div class="case-content-img-box" v-for="(item,index) in currentCaseList" >
          <img class="case-content-img" :src="item">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import sensorsdata from 'sa-sdk-javascript';

export default {
  name: 'index-case',
  data() {
    return {
      caseContentInfo: [
        {
          title: '渠道合作',
          list: [
            'https://o.666visa.cn/static/ssqpeer/homepage/partner/channel/1.png',
            'https://o.666visa.cn/static/ssqpeer/homepage/partner/channel/2.png',
            'https://o.666visa.cn/static/ssqpeer/homepage/partner/channel/3.png',
            'https://o.666visa.cn/static/ssqpeer/homepage/partner/channel/4.png',
            'https://o.666visa.cn/static/ssqpeer/homepage/partner/channel/5.png',
            'https://o.666visa.cn/static/ssqpeer/homepage/partner/channel/6.png',
            'https://o.666visa.cn/static/ssqpeer/homepage/partner/channel/7.png',
            'https://o.666visa.cn/static/ssqpeer/homepage/partner/channel/8.png',
            'https://o.666visa.cn/static/ssqpeer/homepage/partner/channel/9.png',
            'https://o.666visa.cn/static/ssqpeer/homepage/partner/channel/10.png',
            'https://o.666visa.cn/static/ssqpeer/homepage/partner/channel/11.png',
            'https://o.666visa.cn/static/ssqpeer/homepage/partner/channel/12.png',
            'https://o.666visa.cn/static/ssqpeer/homepage/partner/channel/13.png',
            'https://o.666visa.cn/static/ssqpeer/homepage/partner/channel/14.png',
            'https://o.666visa.cn/static/ssqpeer/homepage/partner/channel/15.png',
          ],
        },
        {
          title: '旅业客户',
          list: [
            'https://o.666visa.cn/static/ssqpeer/homepage/partner/travel/1.png',
            'https://o.666visa.cn/static/ssqpeer/homepage/partner/travel/2.png',
            'https://o.666visa.cn/static/ssqpeer/homepage/partner/travel/3.png',
            'https://o.666visa.cn/static/ssqpeer/homepage/partner/travel/4.png',
            'https://o.666visa.cn/static/ssqpeer/homepage/partner/travel/5.png',
            'https://o.666visa.cn/static/ssqpeer/homepage/partner/travel/6.png',
            'https://o.666visa.cn/static/ssqpeer/homepage/partner/travel/7.png',
            'https://o.666visa.cn/static/ssqpeer/homepage/partner/travel/8.png',
            'https://o.666visa.cn/static/ssqpeer/homepage/partner/travel/9.png',
            'https://o.666visa.cn/static/ssqpeer/homepage/partner/travel/10.png',
            'https://o.666visa.cn/static/ssqpeer/homepage/partner/travel/11.png',
          ],
        },
      ],
      activeIndex: 0,
    };
  },
  computed: {
    currentCaseList() {
      return this.caseContentInfo[this.activeIndex].list;
    },
  },
  methods: {
    changeCase(e, index) {
      sensorsdata.quick('trackHeatMap', e.target);
      this.activeIndex = index;
    },
  },
};
</script>
<style lang="less" scoped>
.index-case{
  padding: 58px 0 88px 0;
  background: linear-gradient(180deg, rgba(63, 162, 245, 0.06) 0%, rgba(255, 255, 255, 0.06) 100%);
  .nav-box{
    width: 1000px;
    margin: 0 auto;
    
    border-bottom: 1px solid rgba(233, 238, 242, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    .nav-item{
      color: #666666;
      font-size: 28px;
      height: 76px;
      display: flex;
      align-items: center;
      cursor: pointer;
      position: relative;
      &+.nav-item{
        margin-left: 160px;
      }
      &.active{
        color: #2F333D;
        font-weight: 600;
        &::after{
          content: "";
          width:116px;
          height:8px;
          background:linear-gradient(270deg,rgba(89,159,255,0) 0%,rgba(89,159,255,0.8) 50%,rgba(89,159,255,0) 100%);
          opacity:0.8;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }
  .case-content{
    padding: 32px 46px 32px 46px;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: -32px;

    .case-content-img-box{
      width: 180px;
      height: 96px;
      margin-right: 32px;
      margin-bottom: 32px;
      border-radius: 2px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0px 5px 19px 0px rgba(154,197,255,0.32);
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      &:nth-of-type(5n){
        margin-right: 0;
      }
      .case-content-img{
        height: 100%;
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/index-case.vue